import Controller from "./fulfillmentPlan.controller";
import template from "./fulfillmentPlan.html";

const fulfillmentPlan = {
  template,
  controller: Controller,
};

export default fulfillmentPlan;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/fulfillmentPlan.component.js